import XLRequest from "./request/request";
import { apiUrl } from "../env_config/index";
import qs from "qs";
// import { API_BASE_URL, TIME_OUT } from "./request/config";

const xlRequest = new XLRequest({
  baseURL: apiUrl,
  timeout: 10000,
  interceptorHooks: {
    requestInterceptor: (config) => {
      // const token = localCache.getCache("token");
      // if (token) {
      //   config.headers.Authorization = `Bearer ${token}`;
      // }
      config.data = qs.stringify(config.data, {
        indices: false,
      });
      return config;
    },
    requestInterceptorCatch: (err) => {
      return err;
    },
    responseInterceptor: (res) => {
      return res;
    },
    responseInterceptorCatch: (err) => {
      return err;
    },
  },
});

const noBaseurlRequest = new XLRequest({
  baseURL: "",
  timeout: 10000,
  // headers: { "Content-Type": "application/x-www-form-urlencoded" },
  interceptorHooks: {
    requestInterceptor: (config) => {
      config.data = qs.stringify(config.data, {
        indices: false,
      });
      return config;
    },
    requestInterceptorCatch: (err) => {
      return err;
    },
    responseInterceptor: (res) => {
      return res;
    },
    responseInterceptorCatch: (err) => {
      return err;
    },
  },
});

export default xlRequest;
export { noBaseurlRequest };
